export default "__VITE_ASSET__2d603721__"